<template>
<!-- 完善资料 -->
  <el-dialog
    title="完善资料"
    :visible.sync="dialogVisible"
    width="462px"
    custom-class="improveData-style"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    >
    <div class="content">
      <p class="label-name">请选择您所擅长的市场</p>
      <div class="select-ID-radio">
        <div v-for="item in serverObj" :key="item.key" @click="changeID(item.key)">
          <span class="icon" :class="{'Not_selected' : serviceType !== item.key}">
            <img v-if="serviceType === item.key" :src="icon" alt=""/>
          </span>
          <span>{{ item.name }}</span>
        </div>
      </div>
      <el-cascader
        v-show="serviceType === 3"
        v-model="region"
        placeholder="请选择地区"
        collapse-tags
        :show-all-levels="false"
        clearable
        :options="regionObj"
        :props="{ multiple: true, value: 'id', label: 'chLabel' }"
        @change="changeRegion"
        filterable></el-cascader>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { getCityList, saveInformation } from "../../../api/accountManage";
  import { getTreeData, setCascaderData } from "../../../tool";

  export default {
    name: "improveData",
    data() {
      return {
        dialogVisible: false,
        serviceType: 1,
        serverObj: [
          { key: 2, name: "内销" },
          { key: 3, name: "外销" },
          { key: 1, name: "不区分" }
        ], // 市场类型，0未设置，1非典型，2内销，3外销
        icon: require("../../../assets/img/Select.png"),
        region: [],
        regionObj: [],
        copyRegionTyope: [] // 地区数据
      };
    },
    methods: {
      // 地区
      changeRegion() {
        if (this.region.length > 50) {
          this.region = this.copyRegionTyope;
          this.$message.warning("最多可以选择50个地区~");
        }
        this.copyRegionTyope = JSON.parse(JSON.stringify(this.region));
      },
      changeID(key) {
        this.serviceType = key;
        if (key === 3 && !this.regionObj.length) {
          // 地区
          getCityList().then(res => {
            let { code, data } = res;
            if (code === 1) {
              this.regionObj = getTreeData(data);
              this.regionObj.forEach(item => {
                if (item && item.children) {
                  item.children.forEach(el => {
                    if (el && el.children) {
                      el.children.forEach(e => {
                        e.children = undefined; // 外销地区不显示城市
                      });
                    }
                  });
                }
              });
            }
          });
        } else if (key !== 3) {
          this.region = [];
        }
      },
      changeDialogVisible() {
        this.dialogVisible = !this.dialogVisible;
      },
      submit() {
        if (this.serviceType === 3 && !this.region.length) {
          this.$message.warning("请选择您的外销市场地区");
        } else {
          // 保存租户关注的各项信息
          saveInformation({
            market: {
              type: this.serviceType,
              area: setCascaderData(this.regionObj, ["areaCode", "areaName"], this.region)
            }
          }).then(res => {
            const { code, message } = res;
            if (code === 1) {
              this.changeDialogVisible();
              this.$emit("setSuccess");
            } else {
              this.$message.error(message);
            }
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .improveData-style {
  .el-dialog__header {
    padding: 24px 26px;
  }
  .el-dialog__body {
    .label-name {
      color: #333333;
    }
    .select-ID-radio {
      margin-top: 22px;
      div {
        margin-right: 40px;
        cursor: pointer;
        height: 22px;
        display: inline-block;
        .icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          margin: 0 8px 0 0;
          box-sizing: border-box;
          img {
            width: 100%;
          }
        }
        .Not_selected {
          border: 1px solid #D5D5D5;
          border-radius: 50%;
          background: #fff;
        }
        span {
          font-size: 16px;
          line-height: 16px;
          vertical-align: middle;
          color: #1E282C;
        }
      }
    }
    .el-cascader {
      width: 100%;
      margin-top: 33px;
    }
  }
  .el-dialog__footer {
    padding: 24px 27px 24px;
  }
}
</style>